// extracted by mini-css-extract-plugin
export default {"search":"FooterSearch_search__2HIPU"};